interface Props {
  content: string
  dataTest?: string
  className?: string
}

const ProcessedMarkdown = ({ content, dataTest, className }: Props) => (
  <div
    data-test={dataTest}
    className={className}
    // Content is already sanitized and safe to use in dangerouslySetInnerHTML
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: content as TrustedHTML }}
  />
)

export default ProcessedMarkdown
